import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbVPSHosting = () => {
  return (
    <div
      className="ht__bradcaump__area__resource"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>VPS Hosting</h1>
              <p>
                Trade uninterrupted, anytime, anywhere. Experience powerful
                hosting that keeps your strategies running 24/7, no matter where
                you are.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Get VPS Access
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbVPSHosting.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbVPSHosting;
